import PropTypes from 'prop-types';
import React, { Component } from 'react';
import DropDownButton from '../../../components/ui/DropDownButton';

import faBars from '@fortawesome/fontawesome-pro-light/faBars';

import '../../../styles/ElementsByType.css';

class ElementsByType extends Component {
  static propTypes = {
    toggleRightPanel: PropTypes.func,
    handleCopy: PropTypes.func,
    confirmDelete: PropTypes.func,
  }

  render() {
    const {
      toggleRightPanel,
      handleCopy,
      confirmDelete,
    } = this.props;

    return (
      <div className="float-toolbar-right">
        <DropDownButton
          id="quick-add-btn"
          className={'element-dropdown'}
          title=""
          styleOverrides={{
            background: '#fff',
          }}
          hideToggle
          icon={faBars}
        >
          <a id="quick-add-element"
            className="dropdown-item"
            onClick={toggleRightPanel}
          >
            Edit
          </a>
          <a id="quick-add-element"
            className="dropdown-item"
            onClick={handleCopy}
          >
            Copy
          </a>
          <a id="quick-add-element"
            className="dropdown-item"
            onClick={confirmDelete}
          >
            Delete
          </a>
        </DropDownButton>
      </div>
    );
  }
}

export default ElementsByType;



// WEBPACK FOOTER //
// ./src/views/ProjectSettings/ElementsByType/ElementsByTypeToolbar.js